<div class="card">

    <div class="justify-content-between flex">
        <h1 class="ml-3 mt-3">Promemoria</h1>
        <p-button (onClick)="openCreateModal()" class="mt-3 mr-3" icon="pi pi-plus" label="Crea nuovo promemoria" />
    </div>

    <div class="grid">

        <div class="col-10">

            <div class="search-bar-wrapper">
                <input type="text" pInputText placeholder="Cerca per testo, autore..." [(ngModel)]="testoRicerca"
                    (ngModelChange)="onRicercaChange($event)" />
                @if (testoRicerca) {
                <i class="pi pi-times" role="button" tabindex="0" aria-label="Cancella ricerca" (click)="clearRicerca()"
                    (keydown.enter)="clearRicerca()">
                </i>
                }
            </div>

            @if (listaFiltrata.length === 0 && testoRicerca) {
            <div class="flex flex-column align-items-center justify-content-center text-500 gap-3 mt-6">
                <i class="pi pi-search text-6xl"></i>
                <span class="text-lg">Nessun risultato per "{{ testoRicerca }}"</span>
            </div>
            } @else if (listaPromemorie.length === 0) {
            <div class="flex flex-column align-items-center justify-content-center text-500 gap-3 mt-6">
                <i class="pi pi-list text-6xl"></i>
                <span class="text-lg">Nessun promemoria presente</span>
            </div>
            } @else {
            @for (promemoria of pagedPromemorie; track promemoria.promemoriaId) {
            <div (click)="onSelectPromemoria(promemoria)" onkeypress=""
                [class.selected-card]="selectedPromemoria?.promemoriaId === promemoria.promemoriaId"
                class="card mt-3 surface-ground hover:surface-500 border-round surface-border border-3 text-surface-100 cursor-pointer">
                <div class="justify-content-between flex">
                    <span class="font-bold">{{ promemoria.creatoDa }}</span>
                    <span class="font-semibold">
                        {{ (promemoria.dataModifica ?? promemoria.dataCreazione) | date:'dd/MM/yyyy HH:mm' }}
                    </span>
                </div>
                <pre class="mt-3">{{promemoria.testo}}</pre>
            </div>
            }

            @if (listaFiltrata.length > rows) {
            <div class="card mt-3">
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                    [totalRecords]="listaFiltrata.length" />
            </div>
            }
            }

        </div>

        <div class="col-2">
            @if (listaPromemorie.length > 0) {
            <app-promemoria-dettaglio [selectedPromemoria]="selectedPromemoria"
                (promemoriaAggiornato)="onPromemoriaAggiornato()">
            </app-promemoria-dettaglio>
            }
        </div>

    </div>
</div>

<app-dialog-modal-promemoria [modaleVisibile]="modaleVisibile" [mode]="'create'" (closeDialog)="modaleVisibile = false"
    (success)="onPromemoriaCreato()">
</app-dialog-modal-promemoria>
